/**
 * Hook para listar partners con infinite scroll.
 */
import type { PaginatedPartnersDto } from "common/models";
import { useInfiniteQuery } from "ui/query";
import { Queries } from "ui/query/queries";
import usePartnersFilters from "ui/partners/hooks/usePartnersFilters";
import { config } from "common/config";
import { partnersApi } from "../api/partnersApi";
import type { UseGetPartnerOptions } from "./usePartnerFindAllInfinity.types";

export function usePartnerFindAllInfinity(
    { query, pageSize, page, order, orderBy, type }: UseGetPartnerOptions = {
        pageSize: 10,
        page: 1,
        order: "ASC",
    },
    options?: Parameters<typeof useInfiniteQuery<PaginatedPartnersDto>>[2]
) {
    const params = usePartnersFilters()[0];
    const organizationAddress = config.organization.address;

    return useInfiniteQuery(
        [
            Queries.PARTNERS_FIND_ALL_INFINITY,
            query,
            page,
            pageSize,
            order,
            orderBy,
            params.query,
            type,
            organizationAddress,
        ],
        ({ pageParam = 1 }) =>
            partnersApi
                .findAll({
                    page: pageParam,
                    pageSize,
                    query: params.query || query,
                    order,
                    orderBy,
                    type,
                    organizationAddress,
                    belongsToOtherAlly: false,
                })
                .then((res) => res.data),
        options
    );
}
